export interface Category {
  id: number;
  name: string;
  url: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    id: 1,
    name: 'Buty',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    imageQuery: 'Stylish%20modern%20sneakers%20on%20minimal%20cream%20background%2C%20warm%20lighting%2C%20fashion%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20trendy%20footwear%20display%2C%20elegant%20composition%2C%20neutral%20warm%20tones'
  },
  {
    id: 2,
    name: 'Bluzy/Swetry',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    imageQuery: 'Cozy%20oversized%20hoodie%20on%20warm%20beige%20backdrop%2C%20minimal%20product%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition%2C%20modern%20streetwear%20aesthetic%2C%20neutral%20cream%20tones%2C%20textile%20texture%20visible'
  },
  {
    id: 3,
    name: 'T-Shirty',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    imageQuery: 'Premium%20cotton%20t-shirt%20folded%20on%20cream%20surface%2C%20minimalist%20product%20photography%2C%20warm%20natural%20light%2C%20clean%20aesthetic%2C%20soft%20shadows%2C%20fashion%20catalog%20style%2C%20neutral%20warm%20background'
  },
  {
    id: 4,
    name: 'Kurtki',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    imageQuery: 'Trendy%20bomber%20jacket%20on%20minimal%20warm%20background%2C%20fashion%20product%20photography%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20modern%20outerwear%20display%2C%20neutral%20beige%20tones%2C%20elegant%20composition'
  },
  {
    id: 5,
    name: 'Spodnie/Szorty',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    imageQuery: 'Casual%20trousers%20laid%20flat%20on%20cream%20surface%2C%20minimal%20product%20photography%2C%20warm%20natural%20lighting%2C%20clean%20aesthetic%2C%20modern%20fashion%20display%2C%20neutral%20soft%20tones'
  },
  {
    id: 6,
    name: 'Nakrycia głowy',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    imageQuery: 'Stylish%20baseball%20cap%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20streetwear%20accessory%2C%20neutral%20cream%20tones%2C%20simple%20composition'
  },
  {
    id: 7,
    name: 'Zestawy',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    imageQuery: 'Matching%20clothing%20set%20on%20minimal%20cream%20background%2C%20warm%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20fashion%20display%2C%20neutral%20beige%20tones%2C%20coordinated%20outfit'
  },
  {
    id: 8,
    name: 'Bielizna',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    imageQuery: 'Soft%20cotton%20underwear%20on%20minimal%20warm%20surface%2C%20clean%20product%20photography%2C%20gentle%20lighting%2C%20neutral%20cream%20background%2C%20simple%20composition%2C%20elegant%20aesthetic'
  },
  {
    id: 9,
    name: 'Koszulki sportowe',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    imageQuery: 'Sports%20jersey%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20sportswear%20display%2C%20neutral%20cream%20tones%2C%20dynamic%20fold'
  },
  {
    id: 10,
    name: 'Akcesoria',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    imageQuery: 'Fashion%20accessories%20collection%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20display%2C%20neutral%20beige%20tones%2C%20elegant%20arrangement'
  },
  {
    id: 11,
    name: 'Torby',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    imageQuery: 'Stylish%20bag%20on%20minimal%20cream%20background%2C%20product%20photography%2C%20warm%20lighting%2C%20clean%20aesthetic%2C%20modern%20accessory%20display%2C%20neutral%20beige%20tones%2C%20elegant%20composition'
  },
  {
    id: 12,
    name: 'Paski',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    imageQuery: 'Leather%20belt%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20clean%20aesthetic%2C%20soft%20lighting%2C%20modern%20accessory%20display%2C%20neutral%20cream%20tones%2C%20simple%20composition'
  },
  {
    id: 13,
    name: 'Perfumy',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    imageQuery: 'Elegant%20perfume%20bottle%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20luxury%20display%2C%20neutral%20cream%20tones%2C%20sophisticated%20composition'
  },
  {
    id: 14,
    name: 'Inne',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    imageQuery: 'Various%20fashion%20items%20on%20minimal%20warm%20background%2C%20product%20photography%2C%20soft%20lighting%2C%20clean%20aesthetic%2C%20modern%20display%2C%20neutral%20cream%20tones%2C%20diverse%20collection'
  }
];